export type ExperimentsConfig = {
  GIT_COMMIT_SHA: string;
  OUTSCHOOL_ENV: string;
  EVENT_TRACKING_ENDPOINT: string;
  CLIENT_VERSION?: number;
  SEGMENT_WRITE_KEY?: string;
};

type InternalPackageState = ExperimentsConfig & {
  initialized: boolean;
  isDev?: boolean;
};

const pkg: InternalPackageState = {
  initialized: false,
  GIT_COMMIT_SHA: "",
  OUTSCHOOL_ENV: "",
  EVENT_TRACKING_ENDPOINT: "",
};

export function setPackageState(config: ExperimentsConfig) {
  pkg.GIT_COMMIT_SHA = config.GIT_COMMIT_SHA;
  pkg.OUTSCHOOL_ENV = config.OUTSCHOOL_ENV;
  pkg.EVENT_TRACKING_ENDPOINT = config.EVENT_TRACKING_ENDPOINT;
  pkg.isDev = pkg.OUTSCHOOL_ENV !== "production";

  pkg.initialized = true;

  if (pkg.isDev) {
    console.log("State:", pkg);
  }
}

export default pkg;
